import { Container, Grid, Typography } from "@mui/material";
import React from "react";
import Heading from "../components/heading";
import RevenueImg from '../assets/revenueimage.png';
import { AllImage } from "../styling/style";
import styled from "@emotion/styled";
import RevLogo from '../assets/revenuelogimg.png';
import RevSmallImg from '../assets/revsmallimg.png'; 

const RevenueGrid = styled(Grid)`
    display: flex;
    justify-content: center;
    position: relative;
`
const RevRegular = styled(Typography)`
    color: #FFFFFF;
    font-family: poppins-regular;
    text-align: ${props=>props.ta? props.ta : 'center'};
    @media (max-width: 900px){
        display: ${props=>props.sd? props.sd : 'none'};
    }
`
const RevDetails = styled(Typography)`
    color: #FFFFFF;
    font-family: ${props=>props.ff? props.ff : 'poppins-semibold'};
    font-size: 18px;
    position: absolute;
    text-align: center;
    top: ${props => props.t? props.t : ''};
    bottom: ${props => props.b? props.b : ''};
    right: ${props => props.r? props.r : ''};
    left: ${props => props.l? props.l : ''};
    transform: ${props=>props.trs? props.trs : ''};
    @media (max-width: 600px){
        font-size: 10px;
    }
    @media (max-width: 900px){
        display: none;
    }
    @media (min-width: 900px) and (max-width: 1000px)  {
       top: ${props => props.ts? props.ts : ''};
       bottom: ${props => props.bs? props.bs : ''};
       right: ${props => props.rs? props.rs : ''};
       left: ${props => props.ls? props.ls : ''};
       display: ${props => props.ds? props.ds : ''};
    }
    
`
const RevLogoImg = styled(AllImage)`
    max-width: 330px;
    position: absolute;
    top: 30%;
    left: 34%;
    @media (max-width: 600px){
        max-width: 100px;
    }
    @media (max-width: 900px){
        display: none;
    }
`
const RevSmall = styled(AllImage)`
    display: none;
    @media (max-width: 599px){
        display: block;
        max-width: 800px;
        padding: 10% 0% 0%;
    }
`
const RevBig = styled(AllImage)`
    display: flex;
    justify-content: center;
    max-width: 100%;
    @media (max-width: 599px){
        display: none;
    }
    @media (min-width: 900px) and (max-width: 1100px)  {
       max-width: 700px;
    }
`
const Revenue = () => {
    return(
        <Container maxWidth='lg'>
            <Grid Container>
                <Heading
                     title = 'Revenue Sharing Mechanism'
                     p = '5% 0% 1%'
                     fs='30px'
                />
                <Grid xs={12} sx={{textAlign: 'center', padding: '5% 0% 1%'}}>
                    <RevRegular variant="subtitle-1">e.g. 0.2 Eth send to community trader</RevRegular>

                </Grid>
                <RevenueGrid xs={12} data-aos="zoom-in" data-aos-duration="1200">
                    <RevSmall src={RevSmallImg}/>
                    <RevBig src={RevenueImg}/>
                    {/* <RevDetails variant="subtitle-1" trs =' rotate(90deg)' ff='poppins-regular' t='10%' r='3%' ds='none'>Traded using our bot</RevDetails>
                    <RevDetails variant="subtitle-1" t='8%' l='16%'>2% Of Transaction Taxes</RevDetails>
                    <RevDetails variant="subtitle-1" t='8%' l='62%'>Community Traders</RevDetails> */}
                    {/* <RevLogoImg src={RevLogo}/> */}
                    {/* <RevDetails variant="subtitle-1" t='55%' l='8%' ls='2%'>Wall Of Fame Revenue</RevDetails>
                    <RevDetails variant="subtitle-1" t='55%' r='13%' rs='8%'>0.5% Deposit Tax <br/>+<br/>5% Trade Profit Tax</RevDetails>
                    <RevDetails variant="subtitle-1" b='-11%' l='22%'><span style={{color: '#F3695D'}}>50%</span> <br/>Buy Back And Burn</RevDetails>
                    <RevDetails variant="subtitle-1" b='-11%' r='22%'><span style={{color: '#F3695D'}}>50%</span>  <br/>Distributed To Holders</RevDetails> */}
                </RevenueGrid>
                <Grid xs={12} sx={{padding: "10% 0% 2%"}} data-aos="fade-up" data-aos-anchor-placement="center-bottom">
                    <RevRegular ta="left" variant="subtitle-1" sd='block'><span style={{fontFamily: 'poppins-bold'}}>There are three revenue sources: <br /><br /></span> 1. Bot subscription: Peachy trader bot subscription will be 10$/M. All the subscription revenue will used for $PEACHY buyback and burn. <br />
                        2. Taxes: There is 2% trading tax on each buy/sell. 50% of taxes will be transferred to trades pool and 50% into dev wallet. <br />
                        3. Trades: Trade pool will be used to snipe into alpha signals provided by Peachy trader bot and the gains will be distributed as : 50% distributed to holders and 50% used for buyback and burn $PEACHY.</RevRegular>
                </Grid>
            </Grid>
        </Container>
    )
}
export default Revenue